import { DirectionType } from 'antd/lib/config-provider/context';

export type configInterfaceKeyNames = 'siteConfig' | 'modulesConfigs' | 'pages' | 'layouts' | 'theme';
export interface configInterface {
  siteConfig: SiteConfig;
  modulesConfigs: modulesConfigs & Record<string, any>;
  pages: pagesInterface[];
  layouts: any;
  theme: themeInterface;
}

export enum DynamicPageType {
  PROMOTION = 'promotion',
  DESTINATION = 'destination',
  GENERAL = 'general',
}

export interface ratesInterface extends Record<string,any> {
  // "$": number;
  // "€": number;
  '\u0024': number;
  '\u20AC': number;
}

interface MembershipConfig {
  auth_type: string,
  title?: string,
  allowlist?: string[],
  showNewsletterCheck?: boolean,
  legal?: {
    termsUrl?: string,
  },
  requireMembership?: number,
  subtitle?: string,
  backgroundImage?: string,
}

export interface SiteConfig {
  installments?: {
    maxPaymentsNoCredit: number;
    maxPaymentsWithCredit: number;
    interest_monthly_gap: number;
  };
  membership?: MembershipConfig,
  cssStyle?:string;
  packageDestinations?:Record<any,any>[]
  flightDestinations:Record<any,any>[],
  cityDestinations:Record<any,any>[],
  hotelId:string
  defaultDestinationCity:string;
  defaultDepartureCity:string;
  defaultDestination:string;
  defaultDeparture:string;
  type: string;
  defaultLang: string;
  direction: DirectionType;
  languages: {
    code: string;
    dir: 'ltr' | 'rtl';
    name: string;
  }[];
  name: string;
  logo: string;
  logoSmall: string;
  rightImage: string;
  leftImage?: string;
  dateFormat: string;
  domain: string;
  rates: ratesInterface;
  defaultDate: {
    from: string;
    range: string;
  };
  style: {
    topClass: string;
  };
  hotelStar: string[];
  boardBasis: string[];
  destinations: {
    local: [
      {
        value: string;
        label: string;
      }
    ];
    abroad: [
      {
        value: string;
        label: string;
      }
    ];
  };
  accessibility?: {
    siteKey?: string;
  };
  occupancy: { adult: number; child: number }[];
  email: {
    value: string;
    title: string;
    additionalText: string;
  };
  phone: {
    value: string;
    title: string;
    hours?: string;
  };
  facebook: {
    value: string;
    title: string;
  };
  tiktok?: {
    value: string;
    title: string;
  };

  instagram: {
    value: string;
    title: string;
  };
  whatsapp: {
    phone: string;
    introMessage: string;
    countryCode: string;
  };
  companyInfo: {
    value: string;
    title: string;
    address?: string;
  };
  searchConfig:Record<string,{
    ts_type?: number
    enable_calender_price_api: boolean,
    favorite_locations:any,
  } >
  leadingMainImage?:string,
  ags?:string,
  localInventoryDomain?:any,
  shareB2C?: {
    dp?: number;
    cashback?: any;
    is_guide_explorer_b2c_enabled?: boolean;
  };
}

export interface themeInterface {
  primary?: string;
  secondary?: string;
  tertiary?: string;
  text_color?: string;
  background?: string;
  button?: string;
  input?: string;
  fontFamily?: string;
  title?: string;
  fontStyle?: any,
  fontWeight?: any,
  firstGradientColor?:any,
  secondGradientColor?: any
}

// Later import it from shared !!!!
export interface pagesInterface {
  id: string;
  name: string;
  path: string;
  modules: any;
  layout: string;
  type: string;
  seo: {
    title: string;
    desc: string;
  };
  allow_edit?: boolean;
}

export interface link {
  text: string;
  url: string;
  logo?: string;
}

export interface modulesConfigs {
  Header: headerComponentConfig;
  ImgCarousel: ImgCarouselConfig;
  ContactUs: contactUsConfig;
  AboutUs: PageContentConfig;
  Footer: footerConfig;
  Banner: BannerConfig;
  BannerLarge: bannerLargeConfig;
  Description: descriptionConfig;
  DatesSuggestion: SuggestionConfig;
  ActivitiesSuggestion: SuggestionConfig;
  PackageListView: ListViewConfig;
  ActivitiesListView: ListViewConfig;
  SearchDatePicker: SearchDatePickerConfig;
  NotFound404: NotFound404Interface;
  ConceptsList: ConceptsListInterface;
  PackageSearchConfig: PackageSearchConfigInterface;
  Newsletter: newsletterConfig;
}

export interface headerComponentConfig {
  links: link[];
  HeaderSet3Config?: any;
  Socials: [
    {
      key: string;
      value: string;
    }
  ];
  widgetLangs: {
    isActive: boolean;
  };
  widgetSocial: {
    isActive: boolean;
    socials: [
      {
        key: string;
        value: string;
      }
    ];
  };
  set: string;
  module: 'Header';
  logo: string;
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface ImgCarouselConfig {
  module: string;
  carousel: [
    {
      img: string;
      text: string;
    }
  ];
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface contactUsConfig {
  module: string;
  img: string;
  set: string;
  title: string;
  titleLineTwo?: string;
  theme?: themeInterface;
  phone?: {
    phone: string;
    text: string;
    additionalText: string;
  };
  email?: {
    email: string;
    text: string;
    additionalText: string;
  };
  allow_edit?: boolean;
}

export interface PageContentConfig {
  title: string;
  desc_id?: number;
  desc_type?: string;
  theme: themeInterface;
  module: 'PageContent';
  set: string;
  allow_edit?: boolean;
}

export interface footerConfig {
  module: string;
  columns: {
    header: string;
    links: {
      text: string;
      url: string;
    }[];
  }[];
  theme?: themeInterface;
  set: string;
  logo?: string;
  logo2?: string;
  widgetScrollToTop: {
    isActive: boolean;
  };
  allow_edit?: boolean;
}

export interface newsletterConfig {
  module: string;
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface bannerLargeConfig {
  module: string;
  img: string;
  textLine1: string;
  textLine2?: string;
  theme?: themeInterface;
  button: boolean;
  contentWidth?: boolean;
  backSize?: string;
  key: string;
  set: string;
  allow_edit?: boolean;
}

export interface BannerConfig {
  module: string;
  key: string;
  set: string;
  backgroundImg: string;
  text: string;
  title: string;
  link: any;
  blockFreeUser: boolean;

  theme?: themeInterface;
  stylesName?: string;
  env?: string;
  backgroundType?: string | false;
  button?: boolean;
  contentWidth?: boolean;
  backSize?: string;
  availableForPlan?: string;
  allow_edit?: boolean;
  styling?: any;
}

export interface descriptionConfig {
  module: string;
  img: string;
  title: string;
  titleLineTwo?: string;
  description: string;
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface iframeLoaderConfig {
  instance: string;
  module: string;
  page: any;
  promotionRes?: any;
  src: string;
  top?: string;
}

export interface SuggestionConfig {
  module: string;
  buttonText: string;
  url: string;
  title: string;
  titleLineTwo?: string;
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface ListViewConfig {
  FlightListSet2Config?: any;
  title?: string;
  instance: string;
  module: string;
  theme?: themeInterface;
  stylesName: string;
  set: string;
  boxSet?: string;
  env?: string;
  backgroundType: string | false;
  additionalConfig?: any;
  widgetFilterMenu: {
    isActive: boolean;
    title: string;
    titleLineTwo: string;
    listFilters: [
      {
        name: string;
        filters: {
          dates: string;
          limit: string;
          destination: string;
        };
      }
    ];
  };
  isSingleFetch?: boolean;
  defaultFilters: {
    staticFilter?: string;
    limit: number;
    destination: string;
    dates: {
      from: number;
      range: number;
    };
    from_date: string;
    return_date: string;
    result_cache: number;
    unique: number;
  };
  widgetMorePackages: {
    isActive: boolean;
  };
  widgetPackageBoxHeader: {
    isActive: boolean;
    title: string;
    secondTitle?: string;
  };
  allow_edit?: boolean;
}

export interface RoomPricingInterface {
  theme?: themeInterface;
  showInfantSwitch?: boolean;
  set?: string;
}
export interface HotelPageInterface {
  theme?: themeInterface;
  RoomPricingConfig: RoomPricingInterface;
  PackageDetailsConfig: PackageDetailsInterface;
}

export interface SearchDatePickerConfig {
  module: string;
  theme: themeInterface;
  set: string;
  setConfig?: {
    promotionText?: string;
  };
  resultConfig?: {
    theme?: themeInterface;
    boxSet?: string;
  };
  showSearchResults: {
    isActive: boolean;
  };
  widgetDatePickerCarousel: {
    isActive: boolean;
  };
  autoSearch: boolean;
  flightSummary: {
    isActive: boolean;
  };
  widgetVacationTypes: {
    isActive: boolean;
  };
  searchResultType: string;
  searchOptions: [];
  backgroundImg?: string;
  allow_edit?: boolean;
  headerDesignClass?: string;
}

export interface SwitchDatePickerInterface {
  instance?: string;
  module: string;
  theme: themeInterface;
  set: string;
  title?: string;
  showSearchResults: {
    isActive: boolean;
  };
  showFilters: {
    isActive: boolean;
  };
  searchOptions: any[] | string;
  backgroundImg?: string;
  allow_edit?: boolean;
  headerDesignClass?: string;

  default_package_type?: 'DP' | 'ALP';
  hide_regular_packages?: boolean;
  isDynamicPackageSearchWithEvents?: boolean;
  useAsyncSearch?: boolean;
}

export interface ConceptsListInterface {
  module: string;
  theme: themeInterface;
  set: string;
  hotelId: string;
  conceptLimit: string;
  packageLimit: string;
  packageBoxStyle?: string;
  allow_edit?: boolean;
}
export interface ConceptPage {
  module: string;
  theme: themeInterface;
  conceptListConfig: {
    backgroundType: string;
  };
  allow_edit?: boolean;
}

export interface NotFound404Interface {
  module: string;
  image: string | null;
  title: string;
  redirect_title: string;
  redirect_seconds: number;
  theme?: themeInterface;
  allow_edit?: boolean;
}

export interface Feature {
  isActive: number;
  backimage: string;
}

export interface Features {
  [key: string]: Feature;
}

export interface PackageSearchConfigInterface {
  module: string;
  features: Features;
  allow_edit?: boolean;
}

export interface RoomInfoInterface {
  theme?: themeInterface;
  set: string;
  widgetRoomDetails: {
    isActive: boolean;
  };
  widgetRoomFacilities: {
    isActive: boolean;
  };
  widgetRoomPictures: {
    isActive: boolean;
  };
  facilities: [string];
}

export interface ActivitiesInterface {
  theme: themeInterface;
  set: string;
}

export interface PackageDetailsInterface {
  theme: themeInterface;
  showDates: boolean;
  widgetFlights: SharedWidgetInterface;
  widgetHotelInfo: SharedWidgetInterface;
  widgetActivities: SharedWidgetInterface;
}

export interface HotelDetailsInterface {
  theme: themeInterface;
  widgetHotelInfo: SharedWidgetInterface;
  widgetDatePicker: SharedWidgetInterface;
}

export interface DestinationListLightInterface {
  theme: themeInterface;
  set: string;
  linkType: 'packageSearch' | 'destinationPage';
  title?: string;
}

export interface DestinationListInterface {
  theme: themeInterface;
  set: string;
  title?: string;
  linkType: 'packageSearch' | 'destinationPage';
}

export interface SharedWidgetInterface {
  isActive: boolean;
  widgetSet: string;
  theme?: any;
}

export type ModuleNames =
  | 'Header'
  | 'ImgCarousel'
  | 'ContactUs'
  | 'Footer'
  | 'Banner'
  | 'BannerLarge'
  | 'Description'
  | 'DatesSuggestion'
  | 'ActivitiesSuggestion'
  | 'PackageListView'
  | 'ActivitiesListView'
  | 'SearchDatePicker';

// Might be better to move into shared siteConfig interfaces
export interface RemoveEditOverlayType {
  type: 'RemoveEditOverlay';
}
export interface SendAppConfig {
  type: 'SendAppConfig';
  updatedConfig?: any; // configInterface;
}
export interface SetDynamicPageContent{
  type : "SetDynamicPageContent";
  dynamicPageConfig?: any
  instance?: any
}
export interface SendNewDup{
  type: 'SendNewDup';
  module: any;
  pageId: string;
  path: any;
  moduleConfig?: any
}
export interface RestoreParent{
  type: 'RestoreParent';
  page: any;
  pageId: string;
  path: any;
}
export interface SaveWhiteLabelConfig {
  type: 'SaveWhiteLabelConfig';
  whitelabel_config?: any; // configInterface;
}
export interface SendUpdatedAppConfig {
  type: 'SendUpdatedAppConfig';
}
export interface AddNewModuleType {
  type: 'AddNewModule';
  moduleName: string;
  selectedUrl: string;
  layoutId: string;
  pageId: string;
  path: string | string[];
  index: number;
  defaultModuleObj: any;
  pageType: string;
  instance: string;
  // updatedConfigs: configInterface;
}
export interface AddNewLayoutModuleType {
  type: 'AddNewLayoutModule';
  module: string;
  layoutId: string;
  pageType: string;
  index: number;
}
// export interface AddNewLayoutType {
//   type: 'AddNewLayout';
//   module: string;
//   layoutId: string;
//   pageType: string;
//   index: number;
// }
export interface ChangeLayoutType {
  type: 'ChangeLayout';
  updatedLayout: string;
  pageId: string;
  path: string | string[];
}
export interface ChangePageInfoType {
  type: 'ChangePageInfo';
  updatedPageInfo: pagesInterface;
  path: string | string[];
  pageId: string;
}
export interface AddNewLayoutType {
  type: 'AddNewLayout';
  updatedLayouts: Record<string, any>;
}
export interface DefaultThemeType {
  type: 'DefaultTheme';
  theme: Record<string, any>;
}
export interface EditModuleType extends Record<string, any> {
  type: 'EditModule';
}
export interface CreateDupInstanceType extends Record<string, any> {
  type: 'CreateDupInstance';
  // path: string | string[];
  // pageType: string;
  // layoutId: string;
  pageId: string;
  replaceIndex: number;
  selectedPage: pagesInterface;
  selectedModuleInfo: {
    moduleName: string;
    instance: string;
    layoutSection?: string;
    pageId?: string;
    index?: number;
  };
  selectedModuleUpdated: {
    index: number;
    moduleName: string;
    instance: string;
    pageUpdatedModules: string[];
    newDupInstance: any;
  };
  dupModuleObj: any;
}

export interface RevertModuleConfigType extends Record<string, any> {
  type: 'RevertModuleConfig';
  isLayoutUpdate: boolean;
  updatedModulesAr: string[];
}
export interface EditLayoutModuleType extends Record<string, any> {
  type: 'EditLayout';
}

export type SiteEngineConfigEvents =
  | SaveWhiteLabelConfig // done
  | SendAppConfig // done
  | SendUpdatedAppConfig // done
  | DefaultThemeType // done
  | RemoveEditOverlayType // done
  | AddNewModuleType
  | AddNewLayoutType
  | AddNewLayoutModuleType
  | ChangeLayoutType  // done
  | ChangePageInfoType  // done
  | CreateDupInstanceType
  | RevertModuleConfigType
  | EditLayoutModuleType
  | EditModuleType
  | SetDynamicPageContent
  | SendNewDup
  | RestoreParent

// export type SiteEngineEventType = SiteEngineConfigEvents["type"];
// export enum SiteEngineEventEnum {
//   SendUpdatedAppConfig = 'SendUpdatedAppConfig',
//   RemoveEditOverlay = 'RemoveEditOverlay',
//   AddNewModule = 'AddNewModule',
//   AddNewLayout = 'AddNewLayout',
//   ChangeLayout = 'ChangeLayout',
//   AddLayoutNewConfig = 'AddLayoutNewConfig',
//   DefaultTheme = 'DefaultTheme',
//   EditModule = 'EditModule'
// }
